<template>
    <v-dialog v-model="open" persistent max-width="300px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn class="lead-bottom-control-panel__btn" block color="primary" dark v-bind="attrs" v-on="on">
              <v-icon color="white">mdi-email</v-icon>
              <span class="lead-bottom-control-panel__item-text">Email</span>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Send Email</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-container v-if="emailTemplates.length > 0">
                <v-radio-group v-model="templateId">
                    <v-radio
                        v-for="template in emailTemplates"
                        :key="template.id"
                        :label="template.name"
                        :value="template.id"
                    ></v-radio>
                </v-radio-group>
            </v-container>
            <v-container class="d-flex justify-center" v-else>
                No templates
            </v-container>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="() => (open = false)">
                    Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="send" :disabled="templateId === 0">
                    Send
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters, mapActions } from "vuex";

export default {
    name: "SendEmailDialog",
    props: {
        lead: Object,
    },
    data() {
        return {
            open: false,
            templateId: 0,
        };
    },
    computed: {
        ...mapGetters({
            emailTemplates: "templates/emails",
            user: "auth/user",
        }),
    },
    methods: {
        ...mapActions({
            loadEmails: "templates/loadEmails",
            showHandlerSnackbar: "snackbar/showHandlerSnackbar",
        }),
        send() {
            this.$axios.post('/templates/email/send', {
                id: this.templateId,
                lead: this.lead,
                user: this.user,
            }).then(res => {
                this.showHandlerSnackbar({
                    color: "success",
                    text: res.data.message,
                    show: true,
                });
                this.open = false;
            }).catch(e => {
                console.log('error', e);
            });
        },
    },
    mounted() {
        this.loadEmails(this.user.id);
    },
};

</script>